<div [class.row]="isList">
  <ng-container *ngIf="showStatusFilter">
    <div class="mb-3">
      <fgbcl-filter-status-modal
        [filterTypesList]="filterTypesList"
        (filterTypesListEmitter)="handleFilterTypesListEmitter($event)"
        [selectedValues]="selectedState"
        (selectedValuesEmitter)="handleSelectedStateEmitter($event)"
      ></fgbcl-filter-status-modal>
    </div>
  </ng-container>
  <ng-container *ngIf="marketplaceItems$ | async as marketplaceItems; else loadingRef">
    <ng-container *ngIf="filteredMarketplaceItems.length; else noMarketplaceItems">
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.marketplace.sortbar'">
        <fgbcl-sort-bar
          *ngIf="showSortBar"
          class="row w-100"
          [sortBarOptions]="sortBarOptions"
          [itemList]="filteredMarketplaceItems"
          [displayDefaultSort]="true"
          (defaultSortAction)="resetOrder()"
        ></fgbcl-sort-bar>
      </ng-container>

      <div *ngFor="let item of filteredMarketplaceItems" [class.col-lg-4]="isList" [class.col-6]="isList">
        <div class="loyalty-item-container">
          <fgbcl-marketplace-list-item [marketplaceItem]="item" [featuredIcon]="featuredIcon"></fgbcl-marketplace-list-item>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- No results -->
<ng-template #noMarketplaceItems>
  <div class="rewards-placholder">
    <ng-container *ngIf="marketplaceItemView || eventItemView || productsItemView">
      <div class="no-items no-results-placeholder-div">
        <div
          class="svg svg-info vs-svg ms-auto me-auto"
          fgbAnimateSvg
          [inlineSVG]="
            marketplaceItemView
              ? 'assets/images/placeholders/Marketplace.svg'
              : eventItemView
                ? 'assets/images/placeholders/Events.svg'
                : 'assets/images/placeholders/Marketplace.svg'
          "
        ></div>

        <div class="no-results-placeholder">
          {{
            marketplaceItemView
              ? ('marketplace.placeholder.description' | translate)
              : eventItemView
                ? ('events.placeholder.description' | translate)
                : ('products.placeholder.description' | translate)
          }}
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-template>
